import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { useOffer } from "../../../../hooks/offer";
import { CorDeFundo, Anchor } from "../../../../layouts/Default";
import TituloDestaque from "../../../../components/TituloSorriso";
import BlocoTabela from "../../../../components/BlocoTabela";
import { CustomButtom } from "../../../../components/BotaoCTA/styles";
import Loading from "../../../../components/Loading";
import contentfulClient from "../../../../services/contentful";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { 
  FC_FLOW_PRE_URL, 
  FC_FLOW_POS_URL, 
  FC_FLOW_ESTRADA_PRE_URL, 
  FC_FLOW_CIDADE_PRE_URL 
} from '../../../../services/api'

import {
  Wrapper,
  Container,
  CupomContainer,
  Title,
  Text,
  InputContainer,
  Input,
  FooterContainer,
  Link,
  ModalContent,
  ModalHeader,
  ButtonClose,
  TextError
} from "./style";

import { getCoupon } from "src/services/contentful";
import { getPlans } from "src/services/api";
import { useSelector, useDispatch } from "react-redux";
// import { useDispatch } from "react-redux";

const DEFAULT_OFFERS = {
  default: true,
  code: "PARCERIAS",
  logo: "",
  total: {
    pre: {
      numeroMesesBonificacao: 12,
      valor: "R$ 18,90"
    },
    pos: {
      numeroMesesBonificacao: 12,
      valor: "R$ 18,90"
    }
  },
  cidade: {
    numeroMesesBonificacao: 12,
    valor: "R$ 9,90"
  },
  estrada: {
    numeroMesesBonificacao: 12,
    valor: "R$ 14,90"
  },
  regulamento: "..."
};

const selector = state => ({
  component: state.component
});

export default function Planos() {
  const { component } = useSelector(selector);
  const dispatch = useDispatch();
  const {
    parking,
    tolls,
    parkingAndToll,
    couponCardTitle,
    couponCardAuxText,
    couponCardBgColor,
    couponCardTitleColor,
    couponCardAuxTextColor,
    couponCardPrimaryBtnColor,
    couponCardPrimaryBtnTextColor,
    hasSecondaryButton,
    regulamento,
    hasCoupon,
    primaryTextButton,
    secondaryTextButton,
    isGeneric,
    especificsCoupons
  } = component;

  const { currentOffer, setCurrentOffer } = useOffer();
  const [promoCode, setPromoCode] = useState("");
  const [defaultOffer, setDefaultOffer] = useState(DEFAULT_OFFERS);
  const [offers, setOffers] = useState({DEFAULT:  defaultOffer});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);
  const [plan1Checked, setPlan1Checked] = useState(false);
  const [plan2Checked, setPlan2Checked] = useState(false);
  const [plan3Checked, setPlan3Checked] = useState(false);
  const [parkData, setParkData] = useState({
    img: "",
    corBotao: "",
    corTxtBotao: "",
    numParcelas: "",
    firstButtonCoupon: "",
    // regulamento: "",
    title: ""
  });
  const [tollsData, setTollsData] = useState({
    img: "",
    corBotao: "",
    corTxtBotao: "",
    numParcelas: "",
    firstButtonCoupon: "",
    // regulamento: "",
    title: ""
  });
  const [parkingAndTollsData, setParkingAndTollsData] = useState({
    img: "",
    corBotao: "",
    corTxtBotao: "",
    numParcelas: "",
    firstButtonCoupon: "",
    secondButtonCoupon: "",
    // regulamento: "",
    title: ""
  });
  let resizeWindow = () => setWindowWidth(window.innerWidth);

  // Data from store

  const getParking = async id => await contentfulClient.getEntry(id);

  const getTolls = async id => await contentfulClient.getEntry(id);

  const getParkingAndTolls = async id => await contentfulClient.getEntry(id);

  useEffect(() => {
    const getParkingData = id => async () => {
      await getParking(id).then(data => {
        if (data && data !== undefined) {
          setParkData({
            img: data.fields.banner.fields.file.url,
            corBotao: data.fields.corDoBotao,
            corTxtBotao: data.fields.corTextoBotao,
            numParcelas: data.fields.nmeroDeMensalidadesGrtis,
            firstButtonCoupon: data.fields.firstButtonCoupon,
            // regulamento: data.fields.regulamento.content[0].content[0].value,
            title: data.fields.title
          });
        }
      });
    };  

    (async () => {
      if (parking && parking !== "") {
        dispatch(await getParkingData(parking));
      }
    })();
  }, [parking, dispatch]);

  useEffect(() => {
    const getTollsData = id => async () => {
      await getTolls(id).then(data => {
        if (data && data !== undefined) {
          setTollsData({
            img: data.fields.banner.fields.file.url,
            corBotao: data.fields.corDoBotao,
            corTxtBotao: data.fields.corTextoBotao,
            numParcelas: data.fields.nmeroDeMensalidadesGrtis,
            firstButtonCoupon: data.fields.firstButtonCoupon,
            // regulamento: data.fields.regulamento.content[0].content[0].value,
            title: data.fields.title
          });
        }
      });
    };

    (async () => {
      if (tolls && tolls !== "") {
        dispatch(await getTollsData(tolls));
      }
    })();
  }, [tolls, dispatch]);

  useEffect(() => {
    const getParkingAndTollsData = id => async () => {
      await getParkingAndTolls(id).then(data => {
        if (data && data !== undefined) {
          setParkingAndTollsData({
            img: data.fields.banner.fields.file.url,
            corBotao: data.fields.corDoBotao,
            corTxtBotao: data.fields.corTextoBotao,
            numParcelas: data.fields.nmeroDeMensalidadesGrtis,
            firstButtonCoupon: data.fields.firstButtonCoupon,
            secondButtonCoupon: data.fields.secondButtonCoupon,
            // regulamento: data.fields.regulamento.content[0].content[0].value,
            title: data.fields.title
          });
        }
      });
    };

    (async () => {
      if (parkingAndToll && parkingAndToll !== "") {
        dispatch(await getParkingAndTollsData(parkingAndToll));
      }
    })();
  }, [parkingAndToll, dispatch]);

  useEffect(() => {
    setDefaultOffer({
      ...defaultOffer,
      total: {
        pre: {
          numeroMesesBonificacao: parkingAndTollsData.numParcelas,
          valor: "R$ 18,90"
        },
        pos: {
          numeroMesesBonificacao: parkingAndTollsData.numParcelas,
          valor: "R$ 18,90"
        }
      },
      cidade: {
        numeroMesesBonificacao: tollsData.numParcelas,
        valor: "R$ 9,90"
      },
      estrada: {
        numeroMesesBonificacao: parkData.numParcelas,
        valor: "R$ 14,90"
      },
      regulamento: "..."
    });
  }, [tollsData, parkData, parkingAndTollsData])

  useEffect(() => {
    if (hasCoupon === false) {
      setCurrentOffer(defaultOffer);
    }
  }, [hasCoupon, defaultOffer]);

  const result = {
    data: {
      blocoTabela: {
        name: "Jeitos de usar",
        corDeFundo: "Branco",
        componenteCollection: {
          items: [
            {
              name: parkingAndTollsData.title,
              titulo: parkingAndTollsData.title,
              imagem: {
                url: "https://" + parkingAndTollsData.img,
                title: "420x125px" + parkingAndTollsData.title,
                description: null,
                __typename: "Asset"
              },
              linhasDaTabelaCollection: {
                items: [
                  {
                    name: "Sem fidelidade - texto",
                    titulo: null,
                    descricao: "Sem fidelidade",
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    name: "Pre pago e pós pago",
                    titulo: null,
                    descricao: "Pré-pago e Pós-pago",
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    name: "Pague com cartão de crédito ou débito em conta",
                    titulo: null,
                    descricao: "Pague com cartão de crédito ou débito em conta",
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    name: "Valor mínimo da recarga  automática R$50,00",
                    titulo: null,
                    descricao: "Valor mínimo da recarga automática R$50,00",
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    name: "Entrega do adesivo grátis",
                    titulo: null,
                    descricao: "Entrega do adesivo grátis",
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    blur: !currentOffer || !currentOffer.code,
                    name: "Mensalidades Adesivo",
                    titulo: `${currentOffer &&
                      currentOffer?.total?.pre
                        ?.numeroMesesBonificacao} mensalidades grátis`,
                    descricao: null,
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    blur: !currentOffer || !currentOffer.code,
                    name: "Adquira Adesivo - destaque",
                    titulo: "Adquira grátis",
                    descricao: null,
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    blur: !currentOffer || !currentOffer.code,
                    name: "Mensalidade pedagio e estacionamento",
                    titulo: `Após, a partir de ${currentOffer &&
                      currentOffer?.total?.pre?.valor}/mês`,
                    descricao: null,
                    observacao: null,
                    size: "92px",
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  }
                ],
                __typename: "CardInformacoesLinhasDaTabelaCollection"
              },
              botao: {
                blur: !currentOffer || !currentOffer.code,
                label: "Quero pré-pago",
                estilo: "primary",
                external: null,
                cor:
                  currentOffer && currentOffer.promoColor
                    ? currentOffer.promoColor
                    : parkingAndTollsData.corBotao,
                corLabel: parkingAndTollsData.corTxtBotao,
                rota: {
                  endereco: `${FC_FLOW_PRE_URL}?origem=lp&codigo=${hasCoupon ? `${promoCode}PRE` : parkingAndTollsData.firstButtonCoupon}`,
                  tagLabel: "para-voce:pre-pago",
                  __typename: "Rotas"
                },
                __typename: "Botao",
                disabled: !plan1Checked
              },
              botaoExtra: {
                blur: !currentOffer || !currentOffer.code,
                label: "Quero pós-pago",
                estilo: "primary",
                external: null,
                cor:
                  currentOffer && currentOffer.promoColor
                    ? currentOffer.promoColor
                    : parkingAndTollsData.corBotao,
                corLabel: parkingAndTollsData.corTxtBotao,
                rota: {
                  endereco: `${FC_FLOW_POS_URL}?origem=lp&codigo=${hasCoupon ? `${promoCode}POS` : parkingAndTollsData.secondButtonCoupon}`,
                  tagLabel: "para-voce:pos-pago",
                  __typename: "Rotas"
                },
                __typename: "Botao",
                disabled: !plan1Checked
              },
              regulamento: {
                blur: !currentOffer || !currentOffer.code,
                onChange: e => setPlan1Checked(!plan1Checked),
                show: () => setModalOpen(true)
              },
              __typename: "CardInformacoes"
            },
            {
              name: parkData.title,
              titulo: parkData.title,
              imagem: {
                url: "https://" + parkData.img,
                title: "420x125px" + parkData.title,
                description: null,
                __typename: "Asset"
              },
              linhasDaTabelaCollection: {
                items: [
                  {
                    name: "Sem fidelidade - texto",
                    titulo: null,
                    descricao: "Sem fidelidade",
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    name: "Pré-pago",
                    titulo: null,
                    descricao: "Pré-pago",
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    name: "Pague com cartão de crédito",
                    titulo: null,
                    descricao: "Pague com cartão de crédito",
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    name: "Sem valor mínimo de recarga",
                    titulo: null,
                    descricao: "Valor mínimo da recarga automática R$50,00",
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    name: "Entrega do adesivo grátis",
                    titulo: null,
                    descricao: "Entrega do adesivo grátis",
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    blur: !currentOffer || !currentOffer.code,
                    name: "Mensalidades Adesivo",
                    titulo: `${currentOffer &&
                      currentOffer?.estrada
                        ?.numeroMesesBonificacao} mensalidades grátis`,
                    descricao: null,
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    blur: !currentOffer || !currentOffer.code,
                    name: "Adquira Adesivo - destaque",
                    titulo: "Adquira grátis",
                    descricao: null,
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    blur: !currentOffer || !currentOffer.code,
                    name: "Mensalidade pedagio e estacionamento",
                    titulo: `Após, a partir de ${currentOffer &&
                      currentOffer?.estrada?.valor}/mês`,
                    descricao:
                      !currentOffer || !currentOffer.code
                        ? ""
                        : "Adicional de R$ 1,90 por uso em estacionamentos",
                    observacao: "&nbsp;   \n",
                    size: "92px",
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  }
                ],
                __typename: "CardInformacoesLinhasDaTabelaCollection"
              },
              botao: {
                blur: !currentOffer || !currentOffer.code,
                label: "Quero pré-pago",
                estilo: "primary",
                external: null,
                cor:
                  currentOffer && currentOffer.promoColor
                    ? currentOffer.promoColor
                    : parkData.corBotao,
                corLabel: parkData.corTxtBotao,
                rota: {
                  endereco: `${FC_FLOW_ESTRADA_PRE_URL}?origem=lp&codigo=${hasCoupon ? `${promoCode}EST` : parkData.firstButtonCoupon}`,
                  tagLabel: "para-voce:estrada:pre",
                  __typename: "Rotas"
                },
                __typename: "Botao",
                disabled: !plan2Checked
              },
              botaoExtra: null,
              regulamento: {
                blur: !currentOffer || !currentOffer.code,
                onChange: e => setPlan2Checked(!plan2Checked),
                show: () => setModalOpen(true)
              },
              __typename: "CardInformacoes"
            },
            {
              name: tollsData.title,
              titulo: tollsData.title,
              imagem: {
                url: "https://" + tollsData.img,
                title: "420x125px" + tollsData.title,
                description: null,
                __typename: "Asset"
              },
              linhasDaTabelaCollection: {
                items: [
                  {
                    name: "Sem fidelidade - texto",
                    titulo: null,
                    descricao: "Sem fidelidade",
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    name: "Pré-pago",
                    titulo: null,
                    descricao: "Pré-pago",
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    name: "Pague com cartão de crédito",
                    titulo: null,
                    descricao: "Pague com cartão de crédito",
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    name: "Sem valor mínimo de recarga",
                    titulo: null,
                    descricao: "Valor mínimo da recarga automática R$50,00",
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    name: "Entrega do adesivo grátis",
                    titulo: null,
                    descricao: "Entrega do adesivo grátis",
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    blur: !currentOffer || !currentOffer.code,
                    name: "Mensalidades Adesivo",
                    titulo: `${currentOffer &&
                      currentOffer?.cidade
                        ?.numeroMesesBonificacao} mensalidades grátis`,
                    descricao: null,
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    blur: !currentOffer || !currentOffer.code,
                    name: "Adquira Adesivo - destaque",
                    titulo: "Adquira grátis",
                    descricao: null,
                    observacao: null,
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  },
                  {
                    blur: !currentOffer || !currentOffer.code,
                    name: "Mensalidade pedagio e estacionamento",
                    titulo: `Após, a partir de ${currentOffer &&
                      currentOffer?.cidade?.valor}/mês`,
                    descricao:
                      !currentOffer || !currentOffer.code
                        ? ""
                        : "R$ 21,90 no mês que usar em pedágios",
                    observacao: "&nbsp;   \n",
                    size: "92px",
                    iconesCollection: {
                      items: [],
                      __typename: "AssetCollection"
                    },
                    __typename: "GrupoDeTextoInformativo"
                  }
                ],
                __typename: "CardInformacoesLinhasDaTabelaCollection"
              },
              botao: {
                blur: !currentOffer || !currentOffer.code,
                label: "Quero pré-pago",
                estilo: "primary",
                external: null,
                cor:
                  currentOffer && currentOffer.promoColor
                    ? currentOffer.promoColor
                    : tollsData.corBotao,
                corLabel: tollsData.corTxtBotao,
                rota: {
                  endereco: `${FC_FLOW_CIDADE_PRE_URL}?origem=lp&codigo=${hasCoupon ? `${promoCode}CID` : tollsData.firstButtonCoupon}`,
                  tagLabel: "para-voce:pre-pago:estacionamento",
                  __typename: "Rotas"
                },
                __typename: "Botao",
                disabled: !plan3Checked
              },
              botaoExtra: null,
              regulamento: {
                blur: !currentOffer || !currentOffer.code,
                onChange: e => setPlan3Checked(!plan3Checked),
                show: () => setModalOpen(true)
              },
              __typename: "CardInformacoes"
            }
          ],
          __typename: "BlocoTabelaComponenteCollection"
        },
        titulo: {
          titulo: "Jeitos de usar Veloe",
          tamanhoDoTtulo: null,
          iconeSorriso: "ligth",
          descricao: null,
          corDeFundo: null,
          largeWidth: null,
          hidden: null,
          buttonPosition: null,
          principal: null,
          conteudoExtra: null,
          link: null,
          botao: null,
          __typename: "TtuloHeader"
        },
        __typename: "BlocoTabela"
      }
    }
  };

  function filterPlans(items) {
    if (!items) {
      return result.data.blocoTabela.componenteCollection.items;
    }
    
    let filterResult = items;
    
    if (currentOffer) {
      if (
        !currentOffer.total ||
        !currentOffer.total.pre ||
        !currentOffer.total.pos
      ) {
        filterResult = filterResult.filter(
          it => it.name !== parkingAndTollsData.title
          );
        }
      if (!currentOffer.cidade) {
        filterResult = filterResult.filter(it => it.name !== tollsData.title);
      }
      if (!currentOffer.estrada) {
        filterResult = filterResult.filter(it => it.name !== parkData.title);
      }
    } else {
      return items;
    }

    return filterResult;
  }

  //link: {"nome":"Link pedagio","label":"Saiba mais","rota":{"endereco":"/pedagio","tagLabel":"onde-usar:pedagio:para-voce","__typename":"Rotas"},"__typename":"Link"}
  let listaDeCards = filterPlans(
    result.data.blocoTabela.componenteCollection.items
  );
  let titulo = result.data.blocoTabela.titulo;
  // let cor = result.data.blocoTabela.corDeFundo;

  function loadOffer(code) {
    setLoading(true);
    setTimeout(async () => {
      if (offers[code]) {
        const plans = await getPlans(code);
        setCurrentOffer({
          ...offers[code],
          total:
            plans && (plans.total.pre || plans.total.pos)
              ? {
                  pre:
                    plans.total && plans.total.pre
                      ? {
                          numeroMesesBonificacao:
                            plans.total.pre.numeroMesesBonificacao ||
                            parkingAndTollsData.numParcelas,
                          valor: "R$ 18,90"
                        }
                      : null,
                  pos:
                    plans.total && plans.total.pos
                      ? {
                          numeroMesesBonificacao:
                            plans.total.pos.numeroMesesBonificacao ||
                            parkingAndTollsData.numParcelas,
                          valor: "R$ 18,90"
                        }
                      : null
                }
              : null,
          cidade:
            plans && plans.cidade && plans.cidade && plans.cidade.pre
              ? {
                  numeroMesesBonificacao:
                    plans.cidade.pre.numeroMesesBonificacao ||
                    tollsData.numParcelas,
                  valor: "R$ 9,90"
                }
              : null,
          estrada:
            plans && plans.estrada && plans.estrada && plans.estrada.pre
              ? {
                  numeroMesesBonificacao:
                    plans.estrada.pre.numeroMesesBonificacao ||
                    parkData.numParcelas,
                  valor: "R$ 14,90"
                }
              : null
        });
      } else {
        if (hasSecondaryButton) loadDefaultOffer();
        else setError(true);
      }
      setLoading(false);
    }, 1000);
  }

  function loadDefaultOffer() {
    // loadOffer(DEFAULT_OFFERS.DEFAULT.code)
    setCurrentOffer(defaultOffer);
    setPromoCode(defaultOffer.code);
  }

  useEffect(() => {
    getCoupon().then(data => {
      let _offers = {};

      if (isGeneric) {
        const dataCupons = data.fields.cupons.data;
        dataCupons.forEach(item => {
          _offers[item.code] = {
            code: item.code,
            logo: item.logo,
            promoColor: item.promoColor,
            intro: item.intro,
            title: item.title,
            regulamento: item.regulamento
          };
        });
      }
      else {
        especificsCoupons.forEach(item => {
          _offers[item] = {
            code: item,
          }
        })
      }

      if (Object.keys(_offers).length > 0) setOffers(_offers);
    });
  }, [isGeneric, especificsCoupons]);

  useEffect(() => {
    resizeWindow();
    window.addEventListener("resize", resizeWindow);

    return () => window.removeEventListener("resize", resizeWindow);
  }, []);
  
  return (
    <Wrapper id={currentOffer && "plans"}>
      {loading && <Loading />}
      <CorDeFundo cor={couponCardBgColor} noPadding>
        <Anchor id="jeitos-de-usar" top="-70px" />
        <TituloDestaque containerPadding titulo={titulo} />
        <BlocoTabela listaDeCards={listaDeCards} />
      </CorDeFundo>
      {!currentOffer && hasCoupon && (
        <Container id="plans">
          <CupomContainer cor={couponCardBgColor}>
            <Title cor={couponCardTitleColor}>{couponCardTitle}</Title>
            <Text cor={couponCardAuxTextColor}>{couponCardAuxText}</Text>
            <InputContainer>
              <Input
                disabled={loading}
                placeholder="Código promocional"
                value={promoCode}
                onChange={e => {
                  setPromoCode(e.target.value.toUpperCase());
                  setError(false);
                }}
              />
            </InputContainer>
            {!loading && error && (
              <TextError>
                O código informado é inválido, tente outro código.
              </TextError>
            )}
            {windowWidth >= 991 ? (
              <FooterContainer>
                { hasSecondaryButton ? 
                  <Link onClick={loadDefaultOffer} disabled={loading}>
                    {secondaryTextButton}
                  </Link>
                  : ""
                }
                <CustomButtom
                  color="primary"
                  label={primaryTextButton}
                  onBg="light"
                  style={{
                    backgroundColor: couponCardPrimaryBtnColor,
                    color: couponCardPrimaryBtnTextColor,
                    border: undefined
                  }}
                  onClick={() => promoCode.length > 0 && loadOffer(promoCode)}
                  disabled={promoCode.length === 0 || loading}
                />
              </FooterContainer>
            ) : (
              <FooterContainer>
                <CustomButtom
                  color="primary"
                  label={primaryTextButton}
                  onBg="light"
                  style={{
                    backgroundColor: couponCardPrimaryBtnColor,
                    color: couponCardPrimaryBtnTextColor,
                    border: undefined
                  }}
                  onClick={() => promoCode.length > 0 && loadOffer(promoCode)}
                  disabled={ promoCode.length === 0 || loading }
                />
                { hasSecondaryButton ?
                  <div style={{ marginTop: 20 }}>
                    <Link onClick={loadDefaultOffer} disabled={loading}>
                      {secondaryTextButton}
                    </Link>
                  </div>
                  : ""
                }
              </FooterContainer>
            )}
          </CupomContainer>
        </Container>
      )}
      <Modal
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        contentLabel="Example Modal"
      >
        <ModalContent>
          <ModalHeader>
            <ButtonClose
              src="/parcerias/assets/icon-close.png"
              onClick={() => setModalOpen(false)}
            />
          </ModalHeader>
          {!isGeneric || (currentOffer && currentOffer.default) ?
            <div className="modal-container calibri">
              {documentToReactComponents(regulamento)}
            </div>
          : 
            (currentOffer && currentOffer.regulamento) && 
            <div className="modal-container calibri" dangerouslySetInnerHTML={{__html: currentOffer && currentOffer.regulamento}} />
          }
        </ModalContent>
      </Modal>
    </Wrapper>
  );
}
